import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT, Logger } from 'shared';

const logger = new Logger('serverUrlInterceptor');

export const serverUrlInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const environment: any = inject(ENVIRONMENT);
  const isRelativeUrl = !/^https?:\/\//i.test(req.url);
  if (isRelativeUrl) {
    const apiReq = req.clone({ url: environment.serverUrl + req.url });
    logger.log('serverUrlInterceptor', environment.serverUrl + req.url)
    return next(apiReq);
  }
  return next(req);
};
